import PropTypes from 'prop-types';
export const SPOT_IMAGE = PropTypes.shape({
    id: PropTypes.string,
    alt: PropTypes.string,
    /* eslint-disable camelcase */
    url_template: PropTypes.string,
    /* eslint-enable camelcase */
});
export const SPOT_IMAGES = PropTypes.arrayOf(SPOT_IMAGE);
